import { useEffect, useState } from "react";
import classNames from "../../../utils/classNames";
import formatDateTime from "../../../utils/formatDateTime";
import { DateTime } from 'luxon';

export default function WeeklyIntervalSelector({ setValue, getValues }) {
  const [refresh, setRefresh] = useState(false);

  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  const handleDays = (day) => {
    let currentWeekdays = getValues("trigger.weekDays");
    console.log(currentWeekdays)
    if (!currentWeekdays) currentWeekdays = [];

    //add on weekday if not there, otherwise remove
    if (currentWeekdays?.includes(day)) {
      setValue("trigger.weekDays", currentWeekdays.filter(d => d !== day));
    } else {

      if (currentWeekdays == []) {
        setValue("trigger.weekDays", [day]);
      } else {
        currentWeekdays.push(day);
        setValue("trigger.weekDays", currentWeekdays);
      }
    }

    setRefresh(!refresh);
  }

  useEffect(() => {
  }, [refresh])

  const dayStyling = (day) => {
    const currentWeekdays = getValues("trigger.weekDays");

    return classNames(
      "w-8 h-8 rounded-full border border-gray-700 text-xl font-bold",
      (currentWeekdays && currentWeekdays.includes(day)) ? "bg-gray-700 text-white" : ""
    );
  };

  return (
    <div className="mt-6 flex items-center gap-x-2">

      {days.map((day, index) => (
        <button key={index} type="button" onClick={() => handleDays(day)} className={dayStyling(day)} >
          {day.substring(0, 1)}
        </button>
      ))}

      {getValues("trigger.startDateTime") && (
        <>
          <div>
            @ {formatDateTime(getValues("trigger.startDateTime"), DateTime.TIME_SIMPLE)}
          </div>
          <div className="text-sm text-gray-600">
            (From Start Date and Time)
          </div>
        </>
      )}

    </div>
  )

}